import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { Button, Card, CardBody } from "reactstrap";
import { DesktopContainer } from "../layouts";
import { constants, UserContext, } from "../utils";
import { ManageDoublerDefaults, ManageQuoteDefaults, ManageTwistDefaults } from ".";

export default function AdminDefaults() {
   const { currentUser } = useContext(UserContext);
   const navigate = useNavigate();
   const [showDoubler, setShowDoubler] = useState(true);           // Doubler Calculation Defaults
   const [showQuotes, setShowQuotes] = useState(false);            // Price Quote Generator Defaults
   const [showTwist, setShowTwist] = useState(false);              // Twist Calculation Defaults

   useEffect(() => {
      if (!currentUser) return;
      if (!currentUser.isAdmin) {
         toast.error("Unauthorized");
         var nav = constants.ENDPOINTS.home;
         navigate(nav);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentUser])

   function ResetButtons(val) {
      if ((showDoubler && val !== "showDoubler")
         || (!showDoubler && val === "showDoubler"))
         setShowDoubler(!showDoubler);

      if ((showQuotes && val !== "showQuotes")
         || (!showQuotes && val === "showQuotes"))
         setShowQuotes(!showQuotes);

      if ((showTwist && val !== "showTwist")
         || (!showTwist && val === "showTwist"))
         setShowTwist(!showTwist);
   }

   return (
      document.title = `Default Values`,
      <DesktopContainer screenName="Default Values">
         <div className="filter-header sticky-top">
            <div className="dashboard-button-container">
               <Button
                  children={"Doubler Defaults"}
                  className="filter-button"
                  onClick={() => ResetButtons("showDoubler")}
                  active={showDoubler}
               />
               <Button
                  children={"Quote Defaults"}
                  className="filter-button"
                  onClick={() => ResetButtons("showQuotes")}
                  active={showQuotes}
               />
               <Button
                  children={"Twisting Defaults"}
                  className="filter-button"
                  onClick={() => ResetButtons("showTwist")}
                  active={showTwist}
               />
            </div>
         </div>

         {showDoubler ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Doubler & Winding Calculation Defaults</span></div>
                  <hr />
                  <ManageDoublerDefaults />
               </CardBody>
            </Card>
         ) : (false)}

         {showQuotes ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Price Quote Generator Defaults</span></div>
                  <hr />
                  <ManageQuoteDefaults />
               </CardBody>
            </Card>
         ) : (false)}

         {showTwist ? (
            <Card className="dashboard-card" style={{ minWidth: '960px' }}>
               <CardBody>
                  <div><span className="h2 me-2">Manage Twisting Calculation Defaults</span></div>
                  <hr />
                  <ManageTwistDefaults />
               </CardBody>
            </Card>
         ) : (false)}

      </DesktopContainer >
   );
}
